import { Directive, inject, input } from '@angular/core';
import { ComponentSettings } from '../../page-settings';
import { PageSettingsService } from '../../page-settings.service';

@Directive({
  selector: '[softPageSettingsHost]',
  standalone: true,
})
export class PageSettingsHostDirective {

  readonly service = inject(PageSettingsService);
  name = input.required<string>({alias: 'softPageSettingsHost'});

  constructor() { }

  async set(componentSettings: ComponentSettings): Promise<void> {
    const name = this.name();
    await this.service.set(name, componentSettings);
  }
}
